import React from 'react';
import UserSettingsSidebar from './UserSettingsSidebar';
import './AdminPage.styl';
import AdminSidebarContainer from 'components/stateful/admin/AdminSidebarContainer';
import AuthStore from 'stores/AuthStore';

export default class AdminPage extends React.Component {
  render() {
    return (
      <div className="admin-page">
        {AuthStore.getState().user.isAdmin() ? (
          <AdminSidebarContainer key="SearchSidebarContainer" />
        ) : (
          <UserSettingsSidebar />
        )}
        <div className="content">{this.props.children}</div>
      </div>
    );
  }
}
